export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Classement magasin"])},
        "seller_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vendeur"])},
        "reward": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gain"])},
        "show_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir plus"])},
        "show_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir moins"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store ranking"])},
        "seller_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seller"])},
        "reward": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reward"])},
        "show_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show more"])},
        "show_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show less"])}
      }
    }
  })
}
